import { Navigate } from "react-router-dom";
import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";

export default function LegalPage({ data }) {
  if (!data) return <Navigate to="/" replace />;
  return (
    <>
      <PageHead eyebrow={data.eyebrow} titleLines={[data.title]} intro={data.intro} />
      <section className="edge pb-28 md:pb-40" data-testid="legal-content">
        <div className="mx-auto max-w-3xl">
          {data.updated && (
            <p className="mb-10 text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Last updated: {data.updated}
            </p>
          )}
          {data.sections.map((s, i) => (
            <Reveal key={i} className="py-10">
              <h2 className="text-2xl font-light tracking-editorial md:text-3xl">{s.heading}</h2>
              {s.body && (
                <p className="mt-5 text-base leading-relaxed text-muted-foreground">{s.body}</p>
              )}
              {s.bullets && (
                <ul className="mt-5 space-y-3">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex gap-4 text-base leading-relaxed text-muted-foreground">
                      <span className="mt-2.5 h-1 w-1 shrink-0 rounded-full bg-foreground/40" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
